import { useEffect, useMemo } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $specialOffersStore } from '@lib/store';
import { cn, LsbUtils, PaletteUtils } from '@shared/utils';
import type { LifestyleCategoryType } from '@shared/api';
import { OfferCard } from './offerCard';
import { View } from '@widgets';
import { Text } from '@shared/widgets';

interface SpecialOffersProps {
  className?: string;
  type: LifestyleCategoryType;
}

export const SpecialOffers = (props: SpecialOffersProps) => {
  const specialOffersStore = useUnit($specialOffersStore.store);

  const { t } = useTranslation('concierge');

  useEffect(() => {
    $specialOffersStore.events.getSpecialOffers();
    return () => $specialOffersStore.events.clear();
  }, []);

  const specialOffers = useMemo(
    () => LsbUtils.getSpecialOffersByType({ type: props.type, offers: specialOffersStore.data }),
    [props.type, specialOffersStore.data],
  );
  return (
    <section
      className={cn(
        'flex w-full flex-col gap-4 bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <Text weight={PaletteUtils.getPaletteParam('semibold')} size={PaletteUtils.getPaletteParam('2xl', 'xl')}>
        {t('offer.title')}
      </Text>
      <View
        loading={specialOffersStore.loading}
        noData={!specialOffers?.length}
        noDataText={t('offer.noData')}
        error={specialOffersStore.error}
        onRefresh={() => $specialOffersStore.events.getSpecialOffers()}
      >
        <div className='grid grid-cols-[repeat(auto-fill,minmax(16rem,20rem))] gap-4'>
          {specialOffers?.map((offer) => <OfferCard key={offer.id} type={props.type} offer={offer} />)}
        </div>
      </View>
    </section>
  );
};
